import { ServiceResult } from '../models';
import { RecipeCustomerDiary, RevertRecipeCustomerDiaryActionRequest } from '../models/recipe-customer-diary.models';
import ApiService from './api-service';

class RecipeCustomerDiaryService extends ApiService {
  private static classInstance: RecipeCustomerDiaryService;

  private constructor() {
    super('RecipeCustomerDiary');
  }

  public static getInstance(): RecipeCustomerDiaryService {
    if (!this.classInstance) {
      this.classInstance = new RecipeCustomerDiaryService();
    }
    return this.classInstance;
  }

  public getRecipeCustomerDiary(recipeCustomerDiaryId: string): ServiceResult<RecipeCustomerDiary> {
    return this.get(`${this.persistUrl}/GetRecipeCustomerDiary?recipeCustomerDiaryId=${recipeCustomerDiaryId}`);
  }

  public getRecipeCustomerDiaries(
    customerId: string,
    startDate: Date | string,
    endDate: Date | string
  ): ServiceResult<RecipeCustomerDiary[]> {
    const start = typeof startDate === 'string' ? startDate : startDate.toISOString();
    const end = typeof endDate === 'string' ? endDate : endDate.toISOString();
    return this.get(
      `${this.persistUrl}/GetRecipeCustomerDiaries?customerId=${customerId}&startDate=${start}&endDate=${end}`
    );
  }
  public revertRecipeCustomerDiaryAction(request: RevertRecipeCustomerDiaryActionRequest): ServiceResult<undefined> {
    return this.post(`${this.persistUrl}/RevertRecipeCustomerDiaryAction`, request);
  }
}

export default RecipeCustomerDiaryService;
